const en = {
    "Activate the create/remove space tool": "Activate the create/remove space tool",
    "Activate the global connect tool": "Activate the global connect tool",
    "Activate the hand tool": "Activate the hand tool",
    "Activate the lasso tool": "Activate the lasso tool",
    "Ad-hoc": "Ad-hoc",
    "Add Lane above": "Add Lane above",
    "Add Lane below": "Add Lane below",
    "Append ConditionIntermediateCatchEvent": "Append ConditionIntermediateCatchEvent",
    "Append EndEvent": "Append EndEvent",
    "Append Gateway": "Append Gateway",
    "Append Intermediate/Boundary Event": "Append Intermediate/Boundary Event",
    "Append MessageIntermediateCatchEvent": "Append MessageIntermediateCatchEvent",
    "Append ReceiveTask": "Append ReceiveTask",
    "Append SignalIntermediateCatchEvent": "Append SignalIntermediateCatchEvent",
    "Append Task": "Append Task",
    "Append TimerIntermediateCatchEvent": "Append TimerIntermediateCatchEvent",
    "Append compensation activity": "Append compensation activity",
    "Append {type}": "Append {type}",
    "Business Rule Task": "Business Rule Task",
    "Call Activity": "Call Activity",
    "Cancel Boundary Event": "Cancel Boundary Event",
    "Change type": "Change type",
    "Collection": "Collection",
    "Compensation Boundary Event": "Compensation Boundary Event",
    "Compensation End Event": "Compensation End Event",
    "Compensation Intermediate Throw Event": "Compensation Intermediate Throw Event",
    "Compensation Start Event": "Compensation Start Event",
    "Complex Gateway": "Complex Gateway",
    "Conditional Boundary Event": "Conditional Boundary Event",
    "Conditional Boundary Event (non-interrupting)": "Conditional Boundary Event (non-interrupting)",
    "Conditional Flow": "Conditional Flow",
    "Conditional Intermediate Catch Event": "Conditional Intermediate Catch Event",
    "Conditional Start Event": "Conditional Start Event",
    "Conditional Start Event (non-interrupting)": "Conditional Start Event (non-interrupting)",
    "Connect using Association": "Connect using Association",
    "Connect using DataInputAssociation": "Connect using DataInputAssociation",
    "Connect using Sequence/MessageFlow or Association": "Connect using Sequence/MessageFlow or Association",
    "Create DataObjectReference": "Create DataObjectReference",
    "Create DataStoreReference": "Create DataStoreReference",
    "Create EndEvent": "Create EndEvent",
    "Create Gateway": "Create Gateway",
    "Create Group": "Create Group",
    "Create Intermediate/Boundary Event": "Create Intermediate/Boundary Event",
    "Create Pool/Participant": "Create Pool/Participant",
    "Create StartEvent": "Create StartEvent",
    "Create Task": "Create Task",
    "Create expanded SubProcess": "Create expanded SubProcess",
    "Data Object Reference": "Data Object Reference",
    "Data Store Reference": "Data Store Reference",
    "Default Flow": "Default Flow",
    "Divide into three Lanes": "Divide into three Lanes",
    "Divide into two Lanes": "Divide into two Lanes",
    "Empty Pool": "Empty Pool",
    "Empty Pool (removes content)": "Empty Pool (removes content)",
    "End Event": "End Event",
    "Error Boundary Event": "Error Boundary Event",
    "Error End Event": "Error End Event",
    "Error Start Event": "Error Start Event",
    "Escalation Boundary Event": "Escalation Boundary Event",
    "Escalation Boundary Event (non-interrupting)": "Escalation Boundary Event (non-interrupting)",
    "Escalation End Event": "Escalation End Event",
    "Escalation Intermediate Throw Event": "Escalation Intermediate Throw Event",
    "Escalation Start Event": "Escalation Start Event",
    "Escalation Start Event (non-interrupting)": "Escalation Start Event (non-interrupting)",
    "Event Sub Process": "Event Sub Process",
    "Event based Gateway": "Event based Gateway",
    "Exclusive Gateway": "Exclusive Gateway",
    "Inclusive Gateway": "Inclusive Gateway",
    "Intermediate Throw Event": "Intermediate Throw Event",
    "Link Intermediate Catch Event": "Link Intermediate Catch Event",
    "Link Intermediate Throw Event": "Link Intermediate Throw Event",
    "Loop": "Loop",
    "Manual Task": "Manual Task",
    "Message Boundary Event": "Message Boundary Event",
    "Message Boundary Event (non-interrupting)": "Message Boundary Event (non-interrupting)",
    "Message End Event": "Message End Event",
    "Message Intermediate Catch Event": "Message Intermediate Catch Event",
    "Message Intermediate Throw Event": "Message Intermediate Throw Event",
    "Message Start Event": "Message Start Event",
    "Message Start Event (non-interrupting)": "Message Start Event (non-interrupting)",
    "Parallel Gateway": "Parallel Gateway",
    "Parallel Multi Instance": "Parallel Multi Instance",
    "Participant Multiplicity": "Participant Multiplicity",
    "Receive Task": "Receive Task",
    "Remove": "Remove",
    "Script Task": "Script Task",
    "Send Task": "Send Task",
    "Sequence Flow": "Sequence Flow",
    "Sequential Multi Instance": "Sequential Multi Instance",
    "Service Task": "Service Task",
    "Signal Boundary Event": "Signal Boundary Event",
    "Signal Boundary Event (non-interrupting)": "Signal Boundary Event (non-interrupting)",
    "Signal End Event": "Signal End Event",
    "Signal Intermediate Catch Event": "Signal Intermediate Catch Event",
    "Signal Intermediate Throw Event": "Signal Intermediate Throw Event",
    "Signal Start Event": "Signal Start Event",
    "Signal Start Event (non-interrupting)": "Signal Start Event (non-interrupting)",
    "Start Event": "Start Event",
    "Sub Process": "Sub Process",
    "Sub Process (collapsed)": "Sub Process (collapsed)",
    "Sub Process (expanded)": "Sub Process (expanded)",
    "Task": "Task",
    "Terminate End Event": "Terminate End Event",
    "Timer Boundary Event": "Timer Boundary Event",
    "Timer Boundary Event (non-interrupting)": "Timer Boundary Event (non-interrupting)",
    "Timer Intermediate Catch Event": "Timer Intermediate Catch Event",
    "Timer Start Event": "Timer Start Event",
    "Timer Start Event (non-interrupting)": "Timer Start Event (non-interrupting)",
    "Transaction": "Transaction",
    "User Task": "User Task",
    "correcting missing bpmnElement on {plane} to {rootElement}": "correcting missing bpmnElement on {plane} to {rootElement}",
    "element {element} referenced by {referenced}#{property} not yet drawn": "element {element} referenced by {referenced}#{property} not yet drawn",
    "failed to import {element}": "failed to import {element}",
    "flow elements must be children of pools/participants": "flow elements must be children of pools/participants",
    "missing {semantic}#attachedToRef": "missing {semantic}#attachedToRef",
    "multiple DI elements defined for {element}": "multiple DI elements defined for {element}",
    "no bpmnElement referenced in {element}": "no bpmnElement referenced in {element}",
    "no diagram to display": "no diagram to display",
    "no process or collaboration to display": "no process or collaboration to display"
};

export default en;